module.exports = __webpack_public_path__ + "img/audit-icon-dark.c138092d.svg";